module.exports = __webpack_public_path__ + "46f7e4e957ac24c088271275bfd06401.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/princeton_university_2023_chart.png
// module id = 1706
// module chunks = 0